import React from 'react';

import classes from './MSelectList.module.scss';
import { condClass } from 'app/utils/general';
import { IDropdownListOption } from './MSelectList.model';

interface Props<ValueType extends string | number> {
  className?: string;
  listRef: React.RefObject<HTMLUListElement>;
  selected?: ValueType | null;
  options: IDropdownListOption<ValueType>[];
  onOptionClick: (value: ValueType, index: number) => void;
}

const MSelectListView = <ValueType extends string | number>(props: React.PropsWithChildren<Props<ValueType>>): JSX.Element => {
  return (
    <ul ref={props.listRef} className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
      {props.options.map((option: IDropdownListOption<ValueType>, index: number) => {
        return (
          <li
            key={option.value}
            onClick={() => props.onOptionClick(option.value, index)}
            className={classes['item'] + (props.selected === option.value ? ` ${classes['item--selected']}` : '')}
          >
            {option.label}
          </li>
        );
      })}
    </ul>
  );
};

MSelectListView.displayName = 'MSelectListView';
MSelectListView.defaultProps = {};

export default MSelectListView;
